// extracted by mini-css-extract-plugin
export var standaloneTable = "_h2-0";
export var standaloneTableWithBodyFill = "_h2-1";
export var withExtraHeader = "_h2-2";